/**
 * 다양한 백엔드 날짜 형식을 Date로 안전하게 파싱한다.
 *
 * 표준 파서(new Date)가 실패하는 형식(예: 자리수 미패딩 "2026-6-2 1:52:58",
 * 점/슬래시 구분 "2026. 06. 12.", 공백 구분 등)도 구분자에 상관없이
 * 연-월-일(+시:분:초)을 추출해 로컬 Date로 만든다.
 *
 * @param value Date | number[] (Java LocalDateTime 배열) | string | null
 * @returns Date 또는 파싱 불가 시 null
 */
export function parseDateTime(value) {
  if (value == null) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  // Java LocalDateTime이 [y, M, d, h, m, s] 배열로 올 때 (M은 1-base)
  if (Array.isArray(value)) {
    const [y, M = 1, d = 1, h = 0, m = 0, s = 0] = value;
    const date = new Date(y, M - 1, d, h, m, s);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  if (typeof value !== "string") return null;

  // 1차: 표준 파서로 시도, 유효하면 그대로 사용.
  const native = new Date(value);
  if (!Number.isNaN(native.getTime())) return native;

  // 2차: 구분자/자리수 무관하게 Y-M-D(+H:M:S)를 추출.
  const match = value.match(
    /(\d{4})\D+(\d{1,2})\D+(\d{1,2})(?:\D+(\d{1,2})\D+(\d{1,2})(?:\D+(\d{1,2}))?)?/,
  );
  if (!match) return null;

  const [, y, M, d, h = "0", m = "0", s = "0"] = match;
  const date = new Date(+y, +M - 1, +d, +h, +m, +s);
  return Number.isNaN(date.getTime()) ? null : date;
}

export default parseDateTime;
